import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';

export const paramOptions = {
    EMPTY: 'ParamNotSet'
};

export const stepPositions = {
    FIRST: 'first',
    ONLY: 'only',
    LAST: 'last'
};

export const itemStatus = {
    IN_PROGRESS: 'Started',
    NOT_STARTED: 'Not Started',
    COMPLETED: 'Completed'
};

export const insuranceType = {
    HEALTH: 'Health',
    DENTAL: 'Dental'
};

export const allowedRoles = [ALL_USER_ROLES.ADMIN, ALL_USER_ROLES.ISSUER_ADMIN, ALL_USER_ROLES.OPERATIONS];